import React, {
 useContext, useEffect, useState, useRef, 
} from 'react';
import PropTypes from 'prop-types';
import Alert from '@/shared/components/Alert';
import { Modal } from 'react-bootstrap';
import { Button } from '@/shared/components/Button';
import toast from 'react-hot-toast';
import { GlobalContext } from '../../../../context/GlobalContext';
import EditAgentData from './EditAgentData';
import { AuthContext } from '../../../../context/AuthContext';

const RejectedAgentContainer = ({ agentId, statusCode }) => {
    const { userId, countryId } = useContext(AuthContext);
    const [rejectRemark, setRejectRemark] = useState('');
    const { apiGlobal } = useContext(GlobalContext);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [showNotify, setShowNotify] = useState(false);

    const [agentInfo, setAgentInfo] = useState({});
    const isMounted = useRef(true); // To check if the component is still mounted

    // Define fetchAgentData before useEffect to avoid 'used before defined' error
    const fetchAgentData = async () => {
        const formData = new FormData();
        formData.append('id', agentId);
         formData.append('country_id', countryId);
        try {
            const url = await fetch(`${apiGlobal}/agent_data_fetch.php`, {
                method: 'POST',
                body: formData,
            });
            const response = await url.json();
            if (response.message === 'Success' && response.data.length > 0) {
                const agentData = response.data[0];
                console.log(agentData.user_email);
                if (isMounted.current) {
                    setRejectRemark(agentData.reject_reason);
                    setAgentInfo({
                        id: agentData.id,
                        agentName: agentData.name,
                        addressline1: agentData.address1,
                        addressline2: agentData.address2,
                        area: agentData.area,
                        city: agentData.city,
                        state: agentData.state,
                        pincode: agentData.pincode,
                        uan: agentData.uan,
                        location: agentData.location,
                        country: agentData.country,
                        taxId: agentData.tax_id,
                        taxCity: agentData.tax_city,
                        addressProof: agentData.address_proof_file,
                        gstProof: agentData.gst_proof_file,
                        gstNo: agentData.gst_no,
                        gstType: agentData.gst_type,
                        defaultMarkup: agentData.markup,
                        logo: agentData.logo,
                        countryName: agentData.country_name,
                        countryCode: agentData.country_code,
                        countryCodeId: agentData.country_code_id,
                        userPhone: agentData.user_phone,
                        userEmail: agentData.user_email,
                    });
                }
            } else {
                console.error('No agent data or fetch error');
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchAgentData();
        if (statusCode === '0') {
            setShowNotify(true);
        } else if (statusCode === '2') {
            setShowNotify(false);
        }

        return () => {
            isMounted.current = false; // Cleanup on unmount
        };
    }, [statusCode]); // Added statusCode as a dependency

    const editAgentHandler = async (values) => {
        console.log(JSON.stringify(values, null, 2));
        const formData = new FormData();
        formData.append('id', agentId);
        formData.append('agentName', values.agentName);
        formData.append('addressLine1', values.addressline1);
        formData.append('addressLine2', values.addressline2);
        formData.append('user_phone', values.userPhone);
        formData.append('country_code', values.countryCodeId);
        formData.append('area', values.area);
        formData.append('uan', values.uan);
        formData.append('city', values.city);
        formData.append('state', values.state);
        formData.append('country', values.country);
        formData.append('logo', values.file);
        formData.append('gst_no', values.gstNo);
        formData.append('gst_type', values.gstType);
        formData.append('gst_proof_file', values.gstProof);
        formData.append('pincode', values.pincode);
        formData.append('address_proof_file', values.addressProof);
        formData.append('defaultMarkup', values.defaultMarkup);
        formData.append('locationOnMap', values.location);
        formData.append('taxId', values.taxId);
        formData.append('taxCity', values.taxCity);
        formData.append('type', 1);

        formData.append('change_type', 1);
        formData.append('user_id', userId);

        try {
            const response = await fetch(`${apiGlobal}/agent_edit.php`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            if (data.status) {
                toast.success('Agent Edit successful!');
                setShowModalEdit(false);
                setShowNotify(true);
            } else {
                toast.error(data.message || 'Something went wrong. Please try again.');
            }
        } catch (error) {
            toast.error(`An Error Occurred: ${error.message}`);
        }
    };

    if (!agentId) {
        return (
          <div className="rejected-agent-container">
            Agent Id not Found
          </div>
        );
    }

    return (
      <div>
        {showNotify === false && (
        <div>
          <Alert color="danger" closable ButtonText="Show Remark" className="w-75">
            <p><b>Remark!</b> {rejectRemark}</p>
          </Alert>
          <Button variant="primary" onClick={() => setShowModalEdit(true)}>Edit Details</Button>
        </div>
            )}

        {showNotify && (
        <Alert color="info" colored icon>
          <p><b>Information: </b>Details are successfully sent to Admin.</p>
          <p>Contact Admin For Further Information</p>
        </Alert>
            )}

        {/* Edit Agent Modal */}
        <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)} centered size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Edit Agent</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditAgentData agentData={agentInfo} onSubmit={editAgentHandler} />
          </Modal.Body>
        </Modal>
      </div>
    );
};

RejectedAgentContainer.propTypes = {
    agentId: PropTypes.string.isRequired,
    statusCode: PropTypes.string.isRequired,
};

export default RejectedAgentContainer;
